import $ from "./jq";
(function(){
    let $links = $(".j-site-link");
    $links.removeClass("cur");
    let index = 0;
    let href = window.location.href;
    let ids = $.getHrefParam("ids");
    if(/\/article\/(list|view)\/id/.test(href) || ids != "" ){
        index = 1;
    }
    if(/\/fci\#chars/.test(href)){
        index = 2;
    }
    if(/\/fci\#videos/.test(href)){
        index = 3;
    }
    if(/fci\/(index|modile)\/char_list/.test(href) || /fci\/(index|mobile)\/char_detail/.test(href)){
        index = 2;
    }
    $links.eq(index).addClass("cur")
})()